export default __webpack_public_path__ + "static/port-7-3580ad8187766c91daa9dc82ec29d48d.jpeg";